// import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../Utils/Functions/Dexie-Setup";
import { tableConfigs } from "../../Utils/Functions/Table_Configs";
import { useRef, useLayoutEffect, useCallback, useMemo } from "react"

const DatasheetSelect = ({ focus, rowData, setRowData, columnData, active, stopEditing}) => {

    const {tableName, filter, displayFields, required} = columnData;
    const keyField = useMemo(() => tableConfigs[tableName].fields.find(field => field.type === "key").label, [tableName]);
    const createOption = useCallback((records) => {

        return records.map(record => ({
            label: displayFields.map((curr) => record[curr]).join(" | "),
            value: record[keyField],
        }))
    }, [displayFields, keyField])

    const options = useLiveQuery(() => db[tableName].filter(filter).toArray(createOption), [tableName, filter, createOption])
    const selectRef = useRef(null)

    useLayoutEffect(() => {
        if (focus) {
            selectRef.current?.focus()
        } else {
            selectRef.current?.blur()
        }
    }, [focus])

    return (
        <>
        {/* {
            active ?  */}

        <Select
        // {...(!active ? {hidden:"hidden"} : {})}
        required//={!!(required)}
        ref={selectRef}
            isClearable
            menuIsOpen={focus}
            menuPortalTarget={document.body}
            onChange={(value) => {
                setRowData(value?.value ?? null);
                setTimeout(() => stopEditing({nextRow: false}), 0)
            }}
            onMenuClose={() => stopEditing({nextRow: false})}
            options={options}
            
            value={options?.find(({value}) => value === rowData) ?? null}
            styles={{
                container: (provided) => ({
                    ...provided,
                    flex: 1, // full width
                    alignSelf: 'stretch', // full height
                    pointerEvents: focus ? undefined : 'none',
                }),
                control: (provided) => ({
                    ...provided,
                    height: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    background: 'none',
                }),
                // indicatorSeparator: (provided) => ({
                    //     ...provided,
                //     opacity: 0,
                // }),
                indicatorsContainer: (provided) => ({
                    ...provided,
                    ...(!active ? {display:"none"} : {})
                    // opacity: active ? 1 : 0,
                }),
                placeholder: (provided) => ({
                    ...provided,
                    ...(!active ? {display:"none"} : {})
                    // opacity: active ? 1 : 0,
                }),
            }}
            />
            
            {/* <p {...(active ? {hidden:"hidden"} : {})} className='px-2'>{options?.find(({value}) => value === rowData)?.label ?? ""}</p> */}
        {/* } */}
            </>
    )
}

const SelectColumn = ({title, tableName, filter, displayFields}) => ({
    component: DatasheetSelect,
    columnData: {tableName, filter, displayFields},
    disableKeys: true,
    deleteValue: () => null,
    title,
    minWidth: 200,
    copyValue: ({ rowData }) => rowData,
    pasteValue: ({ value }) => Number(value),
})

export default SelectColumn